import { useNavigate, useParams } from 'react-router-dom'
import { Button, Flex, Spinner, Text } from '../../Components'
import { useState, useMemo } from 'react'
import { saveLineaOccupata, useLineaOccupata } from './Functions'
import { invalidateQuery, useCQuery } from '../../Services/QueryCache'
import { FloatInput } from '../Gigi/GigiForm/TransferField/InputForm'
import { InputTime, InputTimeDate } from '../Attendances'
import { Checkbox } from 'primereact/checkbox'

export function LineaOccupata () {
  const { lineaOccupataId } = useParams()
  const navigate = useNavigate()
  const [lineaOccupata, setLineaOccupata, setLineaOccupataUpdates, isSuccess] = useLineaOccupata(lineaOccupataId)
  const { id = '' } = lineaOccupata || {}
  const [checkError, setCheckError] = useState(false)
  const { data: agencies = [], isSuccess: isSuccessAgencies } = useCQuery(['environments'])
  const { data: motivazioniData = [], isSuccess: isSuccessMotivazioni } = useCQuery(['motivazioniAttivita'])

  // Codici motivazioni banca/carta per cui mostrare Mese e Anno (AP, BA, AM, AME, CBS)
  const CODICI_BANCA_CARTA = ['AP', 'BA', 'AM', 'AME', 'CBS']

  // Prepara le opzioni per il dropdown motivazioni
  const elencoMotivazioni = useMemo(() => {
    return motivazioniData
      .map(m => ({ value: m.id, label: m.label, codice: m.codice }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [motivazioniData])

  const showMeseAnno = useMemo(() => {
    const selected = motivazioniData.find(m => m.id === lineaOccupata?.motivazioneId)
    return selected ? CODICI_BANCA_CARTA.includes(selected.codice) : false
  }, [motivazioniData, lineaOccupata?.motivazioneId])

  const opzioniMesi = useMemo(() => [
    { value: 1, label: 'Gennaio' }, { value: 2, label: 'Febbraio' }, { value: 3, label: 'Marzo' },
    { value: 4, label: 'Aprile' }, { value: 5, label: 'Maggio' }, { value: 6, label: 'Giugno' },
    { value: 7, label: 'Luglio' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Settembre' },
    { value: 10, label: 'Ottobre' }, { value: 11, label: 'Novembre' }, { value: 12, label: 'Dicembre' }
  ], [])

  const opzioniAnni = useMemo(() => {
    const currentYear = new Date().getFullYear()
    return Array.from({ length: 4 }, (_, i) => currentYear - i).map(y => ({ value: y, label: String(y) }))
  }, [])

  const save = async () => {
    setCheckError(true)
    if (!lineaOccupata.startDate || !lineaOccupata.endDate || !lineaOccupata.environmentId || !lineaOccupata.motivazioneId) {
      // message e return per uscire dalla funzione
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compila i campi mancanti' })
      return
    }
    setCheckError(false)

    const elaboratedLineaOccupata = { ...lineaOccupata }
    // Imposta anche il campo reason per retrocompatibilità
    const selectedMotivazione = motivazioniData.find(m => m.id === lineaOccupata.motivazioneId)
    if (selectedMotivazione) {
      elaboratedLineaOccupata.reason = selectedMotivazione.codice
    }
    elaboratedLineaOccupata.startDate = new Date(lineaOccupata.startDate)
    elaboratedLineaOccupata.endDate = new Date(lineaOccupata.endDate)
    elaboratedLineaOccupata?.endDate?.setFullYear(elaboratedLineaOccupata.startDate?.getFullYear())
    elaboratedLineaOccupata?.endDate?.setMonth(elaboratedLineaOccupata.startDate?.getMonth())
    elaboratedLineaOccupata?.endDate?.setDate(elaboratedLineaOccupata.startDate?.getDate())
    // se l'orario di fine è inferiore a quello di inizio, setto la data di fine al giorno successivo, altrimenti setto la data di fine uguale a quella di inizio
    if (new Date(lineaOccupata.endDate).getHours() < new Date(lineaOccupata.startDate).getHours() || (new Date(lineaOccupata.endDate).getHours() === new Date(lineaOccupata.startDate).getHours() && new Date(lineaOccupata.endDate).getMinutes() < new Date(lineaOccupata.startDate).getMinutes())) {
      const endDate = new Date(lineaOccupata.endDate)
      endDate.setFullYear(new Date(lineaOccupata.startDate).getFullYear())
      endDate.setMonth(new Date(lineaOccupata.startDate).getMonth())
      endDate.setDate(new Date(lineaOccupata.startDate).getDate() + 1)
      elaboratedLineaOccupata.endDate = endDate
    } else {
      const endDate = new Date(lineaOccupata.endDate)
      endDate.setFullYear(new Date(lineaOccupata.startDate).getFullYear())
      endDate.setMonth(new Date(lineaOccupata.startDate).getMonth())
      endDate.setDate(new Date(lineaOccupata.startDate).getDate())
      elaboratedLineaOccupata.endDate = endDate
    }
    const res = await saveLineaOccupata(elaboratedLineaOccupata)
    if (!res) return
    invalidateQuery(['lineaOccupata', 'lineaOccupataList'])
    res?.id && navigate('/lineaoccupata/list')
    return res
  }

  const isNew = id === 'new'
  if (!isSuccess || !lineaOccupata || !isSuccessAgencies || !isSuccessMotivazioni) return <Spinner />
  return (
    <Flex fw>
      <Text value={`${isNew ? 'Inserisci' : 'Modifica'} Attività`} title bold size={30} />
      <Flex js fw row wrap style={{ marginTop: 20 }}>
        <Flex style={{ width: '49%', marginRight: '1%' }}>
          <InputTimeDate
            value={[new Date(lineaOccupata.startDate), (date) => setLineaOccupata('startDate', date)]}
            error={checkError && !lineaOccupata.startDate}
            label='Data Inizio' labelTime='Ora Inizio'
          />
        </Flex>
        <Flex style={{ width: '49%', marginLeft: '1%' }}>
          <InputTime
            value={[new Date(lineaOccupata.endDate), (date) => setLineaOccupata('endDate', date)]}
            error={checkError && !lineaOccupata.endDate}
            label='Data Fine' labelTime='Ora Fine'
          />
        </Flex>
        <Flex style={{ width: '49%', marginRight: '1%' }}>
          <FloatInput
            type='dropdown' error={checkError && !lineaOccupata.motivazioneId} filter
            value={[lineaOccupata?.motivazioneId, (value) => {
              const selected = motivazioniData.find(m => m.id === value)
              const isBancaCarta = selected && CODICI_BANCA_CARTA.includes(selected.codice)
              setLineaOccupataUpdates({
                motivazioneId: value,
                ...(isBancaCarta ? {} : { meseEstrattoConto: null, annoEstrattoConto: null, righeGestite: null })
              })
            }]}
            options={elencoMotivazioni}
            label='Motivazione' id='motivazioneId'
          />
        </Flex>
        <Flex style={{ width: '49%', marginLeft: '1%' }}>
          <FloatInput
            type='dropdown' error={checkError && !lineaOccupata?.environmentId} filter
            value={[lineaOccupata.environmentId, (value) => setLineaOccupata('environmentId', value)]}
            options={agencies?.sort((a, b) => a.agencyName.localeCompare(b.agencyName))
              ?.map(({ id, agencyName, codClienteNerone }) => ({ label: agencyName + ' - ' + codClienteNerone, value: id }))}
            label='Ragione Sociale Agenzia' id='agencyName'
          />
        </Flex>
        {showMeseAnno && (
          <>
            <Flex style={{ width: '49%', marginRight: '1%' }}>
              <FloatInput
                type='dropdown' filter
                value={[lineaOccupata?.meseEstrattoConto ?? null, (value) => setLineaOccupata('meseEstrattoConto', value)]}
                options={opzioniMesi}
                label='Mese estratto conto' id='meseEstrattoConto'
              />
            </Flex>
            <Flex style={{ width: '49%', marginLeft: '1%' }}>
              <FloatInput
                type='dropdown' filter
                value={[lineaOccupata?.annoEstrattoConto ?? null, (value) => setLineaOccupata('annoEstrattoConto', value)]}
                options={opzioniAnni}
                label='Anno estratto conto' id='annoEstrattoConto'
              />
            </Flex>
            <Flex style={{ width: '49%', marginRight: '1%' }}>
              <FloatInput
                type='numeric'
                value={[lineaOccupata?.righeGestite ?? '', (value) => setLineaOccupata('righeGestite', value != null && value !== '' ? Number(value) : null)]}
                label='Righe gestite' id='righeGestite'
              />
            </Flex>
          </>
        )}
        <FloatInput
          value={[lineaOccupata?.description || '', (data) => setLineaOccupata('description', data)]}
          label='Descrizione attività' id='description' type='multiline'
          style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
        />
        <Flex row fw style={{ marginTop: 20 }}>
          <Flex row style={{ marginRight: 50 }}>
            <Text value='Lavoro da casa' />
            <Checkbox
              value={lineaOccupata?.workFromHome}
              onChange={(e) => setLineaOccupata('workFromHome', e.checked)}
              checked={lineaOccupata?.workFromHome}
              style={{ marginLeft: 10 }}
            />
          </Flex>
          <Flex row>
            <Text value='Recupero Reperibilità' />
            <Checkbox
              value={lineaOccupata?.recuperoReperibilita}
              onChange={(e) => setLineaOccupata('recuperoReperibilita', e.checked)}
              checked={lineaOccupata?.recuperoReperibilita}
              style={{ marginLeft: 10 }}
            />
          </Flex>
        </Flex>
      </Flex>
      <Flex fw row style={{ marginTop: 20 }}>
        <Button label='Salva' icon='fa-duotone fa-check' style={{ marginRight: 10 }} onClick={save} />
        <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/lineaoccupata/list')} />
      </Flex>
    </Flex>
  )
}
